import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-define-grade',
  templateUrl: './define-grade.component.html',
  styleUrls: ['./define-grade.component.scss']
})
export class DefineGradeComponent implements OnInit {
  DefGrdForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  SemArrayTable: [];
  DefineGrid: FormArray;
  @Output() prev = new EventEmitter<void>();
  GridArray: any;
  errorMarks = false;
  submitpayload: any;
  errmsg: any;
  APIService: string;
  constructor(private modalPopupService: ModalpopService,
    public umsService: UmsService, private httpClient: HttpClient,
    private fb: FormBuilder, public router: Router,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.errorMarks = false
    this.DefGrdForm = this.fb.group({
      DefineGrid: new FormArray([]),
    });
    this.getGrid();
    console.log('getGrid() called');

  }

  getDefineGridControls() {
    return (this.DefGrdForm.get('DefineGrid') as FormArray).controls;
  }

  addDefineGrdBtn(i) {
    this.DefineGrid = this.DefGrdForm.get('DefineGrid') as FormArray;
    if (this.DefineGrid.invalid) {
      this.DefineGrid.controls.forEach(element => {
        element.get('GrGrade').markAsTouched();
        element.get('GrPass').markAsTouched();
        element.get('GrExm').markAsTouched();
        element.get('GrMarks').markAsTouched();
        element.get('Grpoints').markAsTouched();
      })
    } else {
      this.addnewDefine(i)
    }

  }

  deleteRow(index) {
    if (index != 0) {
      (<FormArray>this.DefGrdForm.get("DefineGrid")).removeAt(index);
    } else {
      let data = {}
      data['message'] = "First Row Can Not Be Deleted"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    }

  }

  addnewDefine(i) {
    this.DefineGrid = this.DefGrdForm.get('DefineGrid') as FormArray;
    this.DefineGrid.push(
      this.fb.group({
        GrSrNo: new FormControl(i+1),
        GrGrade: new FormControl('', [Validators.required, Validators.pattern('^([A-Za-z]\+)|([A-Za-z])$')]),
        GrPass: new FormControl('', Validators.required,),
        GrExm: new FormControl('', Validators.required),
        GrMarks: new FormControl('', [Validators.required,Validators.pattern(/^\d+(\.\d+)?$/)]),
        Grpoints: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$')]),
        GrEmId: new FormControl(sessionStorage.getItem('EmId'))
      })
    );
  }

  getGrid() {
    this.spinner.show();
    let i = 0;
    const payload = {};
    payload['EmId'] = sessionStorage.getItem('EmId');
    this.umsService.getDefineGrid(payload).subscribe((res) => {
      this.spinner.hide();
      this.DefineGrid = this.DefGrdForm.get('DefineGrid') as FormArray;
      this.DefineGrid.clear();
      if (payload['EmId'] != null && payload['EmId'] != "") {
        if (res.data.length > 0) {
          this.GridArray = res.data;
          this.GridArray.forEach(element => {
            this.preaddnew(element);
          });
        }
        else {
          this.addDefineGrdBtn(i)
        }
      }
      else {
        this.addDefineGrdBtn(i)
      }
    }, (ERROR: HttpErrorResponse) => {
    });
  }

  preaddnew(e) {
    this.DefineGrid = this.DefGrdForm.get('DefineGrid') as FormArray;
    this.DefineGrid.push(
      this.fb.group({
        GrSrNo: new FormControl(e['EgpSrNo']),
        GrGrade: new FormControl(e['GrGrade'], [Validators.required,Validators.pattern('^([A-Za-z]\+)|([A-Za-z])$')]),
        GrPass: new FormControl(e['GrPass'],Validators.required),
        GrExm: new FormControl(e['GrExm'],Validators.required),
        GrMarks: new FormControl(e['GrMarks'], [Validators.required,Validators.pattern(/^\d+(\.\d+)?$/)]),
        Grpoints: new FormControl(e['EgpPoints'], [Validators.required,Validators.pattern('^[0-9]+$')]),
        GrEmId: new FormControl(sessionStorage.getItem('EmId'))
      })
    );

  }

  back() {
    this.prev.emit();
  }

  grade(event: any,i){
    let control = (<FormArray>this.DefGrdForm.get('DefineGrid')).at(i);
    let grade = event.target.value
    const validGrades = ['A', 'A+', 'B', 'B+', 'C', 'C+', 'D', 'D+', 'E', 'O'];

    if (validGrades.includes(grade)){
      control.patchValue({
        GrExm: 'Y',
        GrPass: 'P'
      });
    }
    else{
      control.patchValue({
        GrExm: 'N',
        GrPass: 'F'
      });
    }
    
  }
  enterMarks(rowIndex: number, enteredMarks: number) {
    const currentRow = this.DefineGrid.at(rowIndex);
    currentRow.get('GrMarks').setErrors(null); // Reset error status for the current row
    const aboveRow = this.DefineGrid.at(rowIndex - 1).get('GrMarks');
    if (aboveRow && aboveRow.value <= enteredMarks) {
      currentRow.get('GrMarks').setErrors({ invalid: true }); // Setting error
    }
    else {
      currentRow.get('GrMarks').setErrors(null);
    }
  }

  enterPass(rowIndex: number, pass){
    const currentRow = this.DefineGrid.at(rowIndex);
    currentRow.get('GrPass').setErrors(null); // Reset error status for the current row
    const aboveRow = this.DefineGrid.at(rowIndex - 1).get('GrPass');
    if (aboveRow.value == 'F' && pass == 'P') {

      currentRow.get('GrPass').setErrors({ invalid: true }); // Setting error
    }
    else {
      currentRow.get('GrPass').setErrors(null);
    }
  }

  PassValue(data, i) {
    let control = (<FormArray>this.DefGrdForm.get('DefineGrid')).at(i);
    if (data == 'F') {
      control.patchValue({
        GrExm: 'N',
      });
    }
    // else if(data == 'P'){
    //   control.patchValue({
    //     GrExm: 'Y'
    //   })
    // }
  }

  ExamValue(data, i) {
    let control = (<FormArray>this.DefGrdForm.get('DefineGrid')).at(i);
    if (this.DefineGrid.at(i).get('GrPass').value == 'F') {
      control.patchValue({
        GrExm: 'N',
      });
    }

  }


  submit() {
    this.submitpayload = this.DefGrdForm.value;
    let iserror = false;
    let arr = [];
    arr = this.submitpayload.DefineGrid
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        GrSrNo: arr[0].GrSrNo,
        GrGrade: arr[0].GrGrade,
        GrPass: arr[0].GrPass,
        GrExm: arr[0].GrExm,
        GrMarks: (arr[0].GrMarks),
        Grpoints: (arr[0].Grpoints),
        GrEmId: parseInt(arr[0].GrEmId),
        GrSpFlag: '',
        GrPassMarks: 0,
        GrExmMarks: 0,
        GrMarksTo: 0,
        GrMinPass: '',
        GrFail: '',
      },
    };
    this.httpClient.delete(this.APIService + '/masters/GradesPts', options)
      .subscribe((s) => {
        this.spinner.hide();
        this.submitGrid();
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });

  }

  submitGrid() {
    this.submitpayload = this.DefGrdForm.value;
    let iserror = false;
    let arr = [];
    arr = this.submitpayload.DefineGrid
    var bar = new Promise<void>((resolve, reject) => {
      arr.forEach((value, index, array) => {
        this.umsService.addDefineGrid(value).subscribe(res => {
          if (res.status == false) {
            iserror = true;
            this.errmsg = res.message;
          }
          if (index === array.length - 1) resolve();
        }
          , (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errmsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
      });
    });

    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.update();
      } else {
      }
    });
  }

  

  update(){
    const payload = {};
    payload['EsId'] = '';
    payload['EsCode'] = '';
    payload['EmId'] = sessionStorage.getItem('EmId');
    this.umsService.updateDefineGrid(payload).subscribe((res) => {
     if(res.status){

     }else{

     }
     
    }, (ERROR: HttpErrorResponse) => {
    });
  }
 
}